import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function ProductMockup() {
  return <section className="py-16 px-4 bg-white border-y border-gray-100" data-id="element-173">
      <div className="max-w-5xl mx-auto text-center" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative" data-id="element-175">
          <div className="absolute inset-0 bg-brand-orange/5 rounded-[3rem] transform -rotate-1 scale-105 -z-10" data-id="element-176"></div>
          <img src="https://cdn.magicpatterns.com/uploads/95o7XDogtUFEN4AECsSzXi/Mockup.png" alt="Mockup del Pack Recetas Caseras Saludables para Perros" className="w-full h-auto rounded-2xl shadow-2xl mx-auto max-w-4xl object-contain" data-id="element-177" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-10" data-id="element-178">
          <p className="text-2xl font-bold text-brand-navy mb-8" data-id="element-179">
            Pack digital completo:{' '}
            <span className="text-brand-orange" data-id="element-180">
              Guía principal + 5 bonos prácticos imprimibles
            </span>
          </p>
          <CTAButton data-id="element-181">Quiero el pack completo por $6.36</CTAButton>
        </motion.div>
      </div>
    </section>;
}